export default (contentState, selection) => {
  let startKey = selection.getStartKey()
  let endKey = selection.getEndKey()

  const startBlock = contentState.getBlockForKey(startKey)
  // If multiple blocks has been selected and start selection located straight at the
  // end of the block, do not count that block as selected
  // (start ... end] or )
  if (
    startKey !== endKey &&
    startBlock.getText().length === selection.getStartOffset()
  ) {
    startKey = contentState.getKeyAfter(startKey)
  }
  if (!startKey) {
    return []
  }

  // having end selection at zero location means that this part is not included
  // something like [start...end)
  if (startKey !== endKey && selection.getEndOffset() === 0) {
    endKey = contentState.getKeyBefore(endKey)
  }
  const blocks = [startKey]
  while (startKey && startKey !== endKey) {
    startKey = contentState.getKeyAfter(startKey)
    startKey && blocks.push(startKey)
  }
  return blocks
}
